<template>
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.668 8.667a3.333 3.333 0 005.027.36l2-2A3.333 3.333 0 008.98 2.313l-1.146 1.14" stroke="#262626" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.333 7.333a3.333 3.333 0 00-5.026-.36l-2 2a3.333 3.333 0 004.713 4.714l1.14-1.14" stroke="#262626" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>

<script>
export default {
  name: 'linkSvg',
};
</script>
